import React from "react";
import { useParams } from "react-router-dom";


const CurrencyTable = () => {

  return (
    <div className="utils-home">
          <div style={{ width: '100%', height: '467px', position: 'relative' }}>
      <iframe
        src="https://www.widgets.investing.com/live-currency-cross-rates?theme=darkTheme"
        width="75%"
        height="100%"
        frameBorder="0"
        allowTransparency="true"
        marginWidth="0"
        marginHeight="0"
        title="Currency Cross Rates"
      ></iframe>
    </div>
    </div>
  );
};

export default CurrencyTable;